import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import ParkingZoneRepository from "../../../repositories/ParkingZoneRepository";
import CameraRepository from "../../../repositories/CameraRepository";
import { useNavigate, useParams } from "react-router";
import FormLoading from "../../../components/FormLoading";
import { useCrudForm } from "../../../hooks/crud/Form";
import { useTranslation } from "react-i18next";
import StaticClassifierRepository from "../../../repositories/StaticClassifierRepository";

const Form = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { id } = useParams();
  const repository = new CameraRepository();
  const [parkingZones, setParkingZones] = useState([]);
  const [directionTypes, setDirectionTypes] = useState([]);
  const { form, onSubmit, isSubmitting, hasError, errorMessage } = useCrudForm(
    repository,
    { id: id, onSuccess: () => navigate("/app/cameras") }
  );
  const { control } = form;

  useEffect(async () => {
    const parkingZoneRepository = new ParkingZoneRepository();
    const result = await parkingZoneRepository.getSelector();
    setParkingZones(result.data);

    const classifierRepository = new StaticClassifierRepository();
    setDirectionTypes(classifierRepository.getAllMovingDirections());
  }, []);

  return (
    <form onSubmit={onSubmit}>
      <Grid item xs={12} lg={8}>
        {isSubmitting && <FormLoading />}`{" "}
        <Card>
          <CardHeader title={t("Information")} />
          <Divider />
          <CardContent>
            <Controller
              as={TextField}
              control={control}
              error={hasError("Code")}
              fullWidth
              helperText={errorMessage("Code")}
              label={t("Code")}
              name="Code"
              defaultValue={""}
              variant="outlined"
            />
            <Box mt={3}>
              <Controller
                as={TextField}
                control={control}
                error={hasError("SourceUrl")}
                fullWidth
                helperText={errorMessage("SourceUrl")}
                label={t("Integration ID")}
                name="SourceUrl"
                defaultValue={""}
                variant="outlined"
              />
            </Box>
            <Box mt={3}>
              <Controller
                as={TextField}
                control={control}
                fullWidth
                error={hasError("ParkingZoneId")}
                label={t("Parking zone")}
                name="ParkingZoneId"
                helperText={errorMessage("ParkingZoneId")}
                select
                SelectProps={{ native: true }}
                defaultValue={null}
                variant="outlined"
              >
                <option></option>
                {parkingZones.map((item) => (
                  <option key={item.Id} value={item.Id}>
                    {item.Name}
                  </option>
                ))}
              </Controller>
            </Box>
            <Box mt={3}>
              <Controller
                as={TextField}
                control={control}
                fullWidth
                select
                error={hasError("DefaultDirectionType")}
                label={t("Default direction")}
                name="DefaultDirectionType"
                helperText={errorMessage("DefaultDirectionType")}
                SelectProps={{ native: true }}
                defaultValue={null}
                variant="outlined"
              >
                <option></option>
                {directionTypes.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Controller>
            </Box>
          </CardContent>
        </Card>
        <Box mt={3}>
          <Card>
            <CardHeader title={t("Visibility")} />
            <Divider />
            <CardContent>
              <Controller
                name="IsActive"
                control={control}
                defaultValue={false}
                render={({ value, onChange, checked }) => (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={value}
                        value={value}
                        onChange={(event, value) => onChange(value)}
                      />
                    }
                    label={t("Active")}
                  />
                )}
              />
            </CardContent>
          </Card>
        </Box>
        `
      </Grid>
      <Box mt={2}>
        <Button
          color="secondary"
          variant="contained"
          type="submit"
          name="submit"
          disabled={isSubmitting}
        >
          {t("Save")}
        </Button>
      </Box>
    </form>
  );
};

export default Form;
